var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { InstrumentDescriptionUtils } from '@shared/utils/Instruments/InstrumentDescriptionUtils';
import { WatchlistManager } from '@shared/utils/Managers/WatchlistManager/WatchlistManager';
import { WatchlistSheetsStorageManager } from '@shared/utils/Managers/WatchlistManager/WatchlistSheetsStorageManager';
import { TerceraSymbolLookupBaseDataProvider } from '../../NoNFixedListCore';
import { BaseSettings } from '../../Settings/BaseGeneralSettingsWrapper';
import { TvSymbolConvertor } from '../Convertors/TvSymbolConvertor';
class _TvDefaultWatchlistProvider {
    getDefaultWatchlist() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield WatchlistSheetsStorageManager.syncInOut();
            }
            catch (e) {
                console.warn('TvDefaultWatchlistProvider::Error load session settings');
                return [];
            }
            BaseSettings.reset(); // reset settings to default
            const wlItems = WatchlistManager.getItems();
            if (wlItems.length === 0) {
                return [];
            }
            const dataProvider = new TerceraSymbolLookupBaseDataProvider();
            const defaultItem = wlItems[0]; // Makhnytsky said: "We will use the first list as default"
            const instrDescriptions = defaultItem.getInstrumentDescriptions();
            const symbolNames = [];
            const instruments = yield Promise.all(instrDescriptions.map((instrDescription) => __awaiter(this, void 0, void 0, function* () {
                const interiorId = InstrumentDescriptionUtils.createInteriorId(instrDescription);
                const instrument = yield dataProvider.getInstrumentByName(interiorId);
                return { interiorId, instrument };
            })));
            instruments.forEach(({ instrument }) => {
                if (!isNullOrUndefined(instrument)) {
                    symbolNames.push(TvSymbolConvertor.getFullname(instrument)); // TODO: replace with ticker?
                }
            });
            return symbolNames;
        });
    }
}
export const TvDefaultWatchlistProvider = new _TvDefaultWatchlistProvider();
